import React, { FunctionComponent, memo } from 'react';
import Avatar from 'react-avatar';
import { IAvatarProps } from './types';

export const CircularAvatar: FunctionComponent<IAvatarProps> = memo(
  ({ src, title, color, size, textSizeRatio, classes, styles, cursorPointer = true, onClick }) => {
    const defaultSize = '35';
    const resolvedSize = size ?? defaultSize;

    return (
      <>
        {src ? (
          <img
            src={src}
            alt={title}
            className={classes ?? ''}
            onClick={onClick}
            style={{
              display: 'block',
              borderRadius: '50%',
              objectFit: 'cover',
              height: `${resolvedSize}px`,
              width: `${resolvedSize}px`,
              minHeight: `${resolvedSize}px`,
              minWidth: `${resolvedSize}px`,
              maxHeight: `${resolvedSize}px`,
              maxWidth: `${resolvedSize}px`,
              cursor: cursorPointer || onClick ? 'pointer' : undefined,
              ...styles,
            }}
          />
        ) : (
          <Avatar
            className={`${color ? '' : 'darkGray-bg'} ${classes ?? ''}`}
            title={title}
            name={title}
            maxInitials={2}
            alt={title}
            color={color}
            textSizeRatio={textSizeRatio ?? 2}
            size={resolvedSize}
            round={true}
            onClick={onClick}
            style={cursorPointer || onClick ? { cursor: 'pointer', ...styles } : styles}
          />
        )}
      </>
    );
  },
);
